<template>
  <kd-button
    class="unit-price unit-price-comp"
    type="text"
    :style="{
      width: styles.width && `${$px(styles.width)}px`,
      height: styles.height && `${$px(styles.height)}px`,
      lineHeight: styles.height && `${$px(styles.height)}px`,
    }"
  >
    <img
      class="icon"
      src="../images/icon_ttp@2x.png"
      :width="$px(styles.fontSize || 14)"
      :height="$px(styles.fontSize || 14)"
      alt=""
    />
    <span class="value pp" :style="{ color: styles.color, fontSize: `${styles.fontSize && $px(styles.fontSize)}px` }">
      {{ unitPrice * 10 }}
    </span>
    <span
      class="value op"
      :style="{ color: originalPriceColor, fontSize: `${originalPriceFontSize}px` }"
      v-if="product.is_promotion"
    >
      {{ product.original_price * 10 }}
    </span>
  </kd-button>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { KdButton } from 'kuaidong-ui'
import { ColorUtil } from 'kuaidong-lib'

const props = withDefaults(
  defineProps<{
    styles?: {
      color?: string
      width?: number
      height?: number
      fontSize?: number
      originalPriceColor?: string
    }
    product: {
      is_promotion: boolean
      original_price: number
      promotion_price: number
    }
  }>(),
  {
    styles: () => ({
      color: '#fff',
      fontSize: 16,
    }),
  }
)

const unitPrice = computed(() =>
  props.product.is_promotion ? props.product.promotion_price : props.product.original_price
)

const originalPriceColor = computed(
  () => props.styles.originalPriceColor || (props.styles.color && ColorUtil.hex2RGBA(props.styles.color, 50))
)

const originalPriceFontSize = computed(() => Math.max(props.styles.fontSize ? props.styles.fontSize - 2 : 14, 12))
</script>

<style lang="less">
.kd-button.unit-price-comp {
  align-items: baseline;
  height: unset;

  > .icon {
    align-self: center;
  }

  > .pp {
    margin: 0 2px;
    font-weight: 800;
  }

  > .op {
    font-weight: 400;
    text-decoration: line-through;
  }
}
</style>
